export const isMobile = {
  Android: () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.match(/Android/i);
  },
  BlackBerry: () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.match(/IEMobile/i);
  },
  any: () => {
    if (typeof window === 'undefined') return false;
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

export default isMobile;
